/**
 * Homepage imax carousel
 */

import Glide from '@glidejs/glide';

export default {

	/** @type {Glide} glide instance */
	inst: null,

	/** @type {Object} glide options */
	glideOpts: {
		type: 'carousel',
		perView: 1,
	},

	/**
	 * Initialize
	 */
	init() {

		if(!document.querySelector('#imax-carousel')) return;

		this.inst = new Glide('#imax-carousel', this.glideOpts);

		this.inst.on('mount.before', () => this.bindNav());
		this.inst.mount();
	},

	/**
	 * Bind nav click actions
	 */
	bindNav() {
		const links = document.querySelectorAll('#imax-carousel .slide-nav a');

		for(let i = 0; i < links.length; i++) {
    		links[i].addEventListener('click', e => {
    			e.preventDefault();
    			this.inst.go('=' + e.currentTarget.getAttribute('href').replace('#imax-', ''));
    		});
        }
	},
}